/* Primary Palette */
export const CHART_COLOR_PALETTE_ONE = [
  '#25CCF7',
  '#FD7272',
  '#54a0ff',
  '#00d2d3',
  '#98f5ea',
  '#2ecc71',
  '#ffd200',
  '#7590d2',
  '#79afe2',
  '#836200',
  '#f6f6f6',
  '#ff0093',
  '#c7beff',
  '#5241ef',
  '#f1c40f',
  '#e67e22',
  '#e74c3c',
  '#ecf0f1',
  '#95a5a6',
  '#f39c12',
  '#d35400',
  '#ff8168',
  '#c8caff',
  '#cef1ba',
  '#55efc4',
  '#81ecec',
  '#74b9ff',
  '#a29bfe',
  '#dfe6e9',
  '#00b894',
  '#caf3f2',
  '#0984e3',
  '#ef91f7',
  '#ffeaa7',
  '#fab1a0',
  '#ff7675',
  '#2fa0ef',
  '#fdcb6e',
  '#e17055',
  '#c7aeae',
  '#5ef8cd',
  '#806ab1',
  '#54a0ff',
  '#01a3a4',
];

/* Secondary Palette */
export const CHART_COLOR_PALETTE_TWO = [
  '#7950F2',
  '#4C6EF5',
  '#228BE6',
  '#15AABF',
  '#12B886',
  '#40C057',
  '#82C91E',
  '#D79704',
  '#DF6602',
  '#FA5252',
  '#E64980',
  '#B533D6',
];
